import {
  electricPurple800,
  monserratRegular,
  robotoRegular,
  scarpaGray50,
  scarpaGray500,
} from "@habitech/shared";
import { styled } from "styled-components";

export const WrapperModal = styled.div`
  padding: 24px;
  background: ${scarpaGray50};
  color: ${scarpaGray500};
  border-radius: 8px;
  .subtitle {
    font-family: ${robotoRegular};
    font-weight: 400;
    font-size: 14px;
    padding-bottom: 8px;
  }
  .modal-title {
    font-size: 18px;
    font-weight: bold;
    color: ${electricPurple800};
    font-family: ${monserratRegular};
  }
  .form-label,
  .form-control {
    font-size: 14px;
    font-family: ${robotoRegular};
    padding-bottom: 5px;
  }
  .form-control {
    height: 80px;
  }
  textarea {
    overflow: auto;
    scrollbar-width: none;
  }
  textarea::-webkit-scrollbar {
    display: none;
  }
  .invalid-feedback {
    font-size: 13px;
    font-weight: 600;
    color: #dc3545;
    margin-top: 0;
    font-family: ${robotoRegular};
  }
  .percentage-input {
    height: 35px;
    width: 150px;
    text-align: right;
  }
  .bonus-type-input {
    height: 35px;
  }
  .percentage-label,
  .percentage-amount {
    font-size: 14px;
    font-weight: 600;
    font-family: ${robotoRegular};
  }
`;
